import { render } from "./AdminYellowMeetingList.vue?vue&type=template&id=79c38b19"
import script from "./AdminYellowMeetingList.vue?vue&type=script&lang=js"
export * from "./AdminYellowMeetingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__